import LearningPathManagementService from '../../service/LearningPathManagementService';
import { getLatestLiveScheduledTimestamp } from '../../utils/date';
import {setNotificationData} from './uiActions';

export const SET_ALL_COURSES_LIST = 'SET_ALL_COURSES_LIST';
export const SET_SELECTED_COURSE = 'SET_SELECTED_COURSE';
export const SET_LATEST_LIVE_SCHEDULED_TIMESTAMP = 'SET_LATEST_LIVE_SCHEDULED_TIMESTAMP';
export const SET_SCHEDULING_DATA = 'SET_SCHEDULING_DATA';
export const SET_LINKED_LEARNING_PATHS_OF_COURSE = 'SET_LINKED_LEARNING_PATHS_OF_COURSE';

export const setAllCoursesList = (options) => {
  return {
    type: SET_ALL_COURSES_LIST,
    payload: options,
  };
};

export const setSelectedCourse = (options) => {
  return {
    type: SET_SELECTED_COURSE,
    payload: options,
  };
};

export const setLatestLiveScheduledTimestamp = (options) => {
  return {
    type: SET_LATEST_LIVE_SCHEDULED_TIMESTAMP,
    payload: options,
  };
};

export const setSchedulingData = (options) => {
  return {
    type: SET_SCHEDULING_DATA,
    payload: options,
  };
};

export const setLinkedLearningPathsOfCourse = (options) => {
  return {
    type: SET_LINKED_LEARNING_PATHS_OF_COURSE,
    payload: options,
  };
};

export const fetchLinkedLearningPathsOfCourse = (courseId) => {
  return async (dispatch) => {
    try {
      const response = await LearningPathManagementService.fetchLinkedLearningPathsOfCourse(
        courseId,
      );

      if (response?.data) {
        dispatch(setLinkedLearningPathsOfCourse(response?.data || []))
        const timeStamp = getLatestLiveScheduledTimestamp(response?.data);
        dispatch(setLatestLiveScheduledTimestamp(timeStamp));
      } else {
        dispatch(setLatestLiveScheduledTimestamp(null));
        dispatch(setLinkedLearningPathsOfCourse([]));
      }
    } catch (error) {
      dispatch(setLinkedLearningPathsOfCourse([]));
      console.log('error', error);
      dispatch(setLatestLiveScheduledTimestamp(null));
      dispatch(
        setNotificationData({
          show: true,
          type: 'WARNING',
          title: 'Failed to fetch the learning paths linked to this course.',
          description: error?.message,
        }),
      );
    }
  };
};
